'use client';

import * as React from "react";
import { ReactNode, useCallback, useContext, useMemo } from "react";
import { ll_url } from "./utils/tools";
import { ReinitContext } from "./ReinitContext";
import Nav from "./parts/Nav";
import Main from "./parts/Main";
import Footer from "./parts/Footer";
import { NavLink } from "react-router-dom";
import { toolKeywords, toolName } from "./settings";
import Header from "./parts/Header";
import ColorBar from "./parts/ColorBar";

export function Body({children}: { children: ReactNode }) {
  const {reinitHandlers} = useContext(ReinitContext);

  const setInitialInputState = useCallback(() => {
    for (const handler of reinitHandlers) {
      handler();
    }
  }, [reinitHandlers]);

  const menuItems = useMemo(() => {
    return [
      {target: ll_url('/'), text: 'Submit new job', onClick: setInitialInputState},
      {target: ll_url('/help'), text: 'Help'},
      {target: ll_url('/example'), text: 'Example'},
      {target: ll_url('/acknowledgements'), text: 'Acknowledgements'}
    ]
  }, [setInitialInputState]);

  return (
    <div className="ll-page">

      <Header onClick={setInitialInputState} />
      <ColorBar />
      <Nav menu={menuItems}/>
      <Main>
        {children}
      </Main>

      <Footer>
        <div className="ll-keywords">
          <p><strong>Keywords:</strong> {toolKeywords}</p>
          <p><strong>Disclaimer:</strong> {toolName} is a non-profit service to the academic and nonacademic scientific community. The responsibility of the author is limited to applying best efforts in providing a useful service. The authors can not be held liable in any way for the service provided here.</p>
        </div>
        <div className="ll-terms-privacy">
          <p><NavLink to={ll_url('/terms-of-use')}>Terms of use</NavLink> | <NavLink to={ll_url('/privacy')}>Privacy</NavLink></p>
        </div>
      </Footer>

    </div>
  )
}